export default __webpack_public_path__ + "static/media/akela_rainbow.12ae66cc.jpg";